module.exports = __webpack_public_path__ + "img/wins.ce026986.png";